import React, { FC, useState, useEffect } from 'react';
import './style.scss';
import { hintModalViewStore } from 'src/store/modal';

interface Props {
  title?: any;
  content: any;
  styleDef?: React.CSSProperties;
  type?: string;
}

const HelpIcon: FC<Props> = ({ content, title, styleDef, type = '' }) => {
  const setHintModalState = hintModalViewStore((state: any) => state.set);
  const clickEvt = (e: React.MouseEvent) => {
    const offsetX = 20; // 우측으로 20px
    const offsetY = -10; // 위로 10px (필요에 따라 조정)

    const x = e.clientX;
    const y = e.clientY;

    // 화면 크기
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    // 모달 크기
    const modalWidth = 300;
    const modalHeight = 100;
    let modalX = x + offsetX;
    let modalY = y + offsetY;

    // 오른쪽에 공간이 부족한 경우 왼쪽에 표시
    if (modalX + modalWidth > windowWidth) {
      modalX = x - modalWidth - offsetX;
    }

    // 아래쪽에 공간이 부족한 경우
    if (modalY + modalHeight > windowHeight) {
      modalY = windowHeight - modalHeight - 10; // 10px 여백
    }

    modalX = Math.max(10, modalX); // 최소 10px 여백
    modalY = Math.max(10, modalY);
    // if (status !== '_none') clickEvent(e);
    setHintModalState({
      active: '_active',
      content: content,
      title: title,
      styleDef: {
        ...styleDef,
        position: 'fixed',
        left: `${modalX}px`,
        top: `${modalY}px`,
        transform: 'none',
        zIndex: 1000,
      },
    });
  };

  return (
    <div className="_help_icon_set">
      <div className={`_btn ${type}`} onClick={e => clickEvt(e)}>
        <i className="ri-question-line" />
      </div>
    </div>
  );
};

export default HelpIcon;
